import { FineGibddOrderPayload, FineOrderItemModel } from './mobile-bff-get-rent-fine-orders.response';

export type RentFineModel = FineOrderItemModel<FineGibddOrderPayload>;

export type MobileBffGetRentFinesResponse = {
  rows: RentFineModel[];
  total: number;
};
